import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  The 36 conservation areas identified in the{' '} <InlineLink href="https://www.msa.vic.gov.au/__data/assets/pdf_file/0032/64787/Biodiversity-Conservation-Strategy-Jun-2013.pdf" text="Biodiversity Conservation Strategy for Melbourne’s Growth Corridors (BCS)" mdxType="InlineLink" /> are not located in the MSA Levy Area. No levy applies to conservation areas.
    </p>
    <p>
  For more information about conservation areas, including how conservation areas are protected and managed, refer to the{' '} <InlineLink href="https://www.msa.vic.gov.au/" text="MSA website" mdxType="InlineLink" />.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      